import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SnackBarComponent } from './snack-bar.component';

@Injectable({
	providedIn: 'root',
})
export class SnackBarService {
	constructor(private readonly snackBar: MatSnackBar) {}

	showSnack(info: string, type: string) {
		this.snackBar.openFromComponent(SnackBarComponent, {
			data: { info, type },
		});
	}
}
